import { render, staticRenderFns } from "./nhf-report.vue?vue&type=template&id=1f6aa712&"
import script from "./nhf-report.vue?vue&type=script&lang=js&"
export * from "./nhf-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports